import React, { useEffect, useState } from "react";
import styles from "./PreviewDateTime.module.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { ReactComponent as DateIcon } from "assets/svg/DateIcon.svg";
import date from "../../../../../assets/svg/date.svg"
const PreviewDateTime = (props) => {
  const [startDate, setStartDate] = useState(
    props?.data?.showInstructions || false
  );
  const [showIcon, setShowIcon] = useState(false);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>
            {props?.data?.required && <span style={{ color: "red" }}>*</span>}
            {props?.data?.value || props?.name || props?.label}
          </span>
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>

        <div className={styles.dateContainer}>
          {/* <DateIcon className={styles.dateIcon} /> */}
          <img src={date} alt="date" className={styles.dateIcon} />
          <DatePicker

            selected={startDate}
            className={styles.datePicker}
            onChange={(date) => setStartDate(date)}
            placeholderText={startDate ? startDate : "Select Date"}
            showTimeSelect={props?.includeTimeWithDate} // Conditionally enable time
            timeFormat="HH:mm"
            timeIntervals={15} // Adjust time intervals (e.g., every 15 minutes)
            timeCaption="Time"
            dateFormat={true ? "MMMM d, yyyy h:mm aa" : "MMMM d, yyyy"}
          />
        </div>
      </div>
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PreviewDateTime;
